// extracted by mini-css-extract-plugin
export default {"productSearchDescription":"mgYGoH8K6FWEmo8LQGsz-ProductSearchDescription-productSearchDescription"};